import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  OneToMany,
  PrimaryGeneratedColumn
} from 'typeorm';
import { Produto } from './Produto';

@Entity()
export class Categoria {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  descricao: string = '';

  @Column()
  relevancia: number = 0;

  @OneToMany(() => Produto, (produto: Produto) => produto.categoria)
  produtos!: Produto[];

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default Categoria;
